import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { processSurveyAnswers } from "../insight/index";
import BubbleChart from "../bubble_chart";
import Graph from "./slopeChart.js";
const Recommendations = () => {
  const themeMode = useSelector((state) => state.themeMode);
  const chartRef = useRef(null);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;
  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  const [totalAnswers, setTotalAnswers] = useState([]);
  const graphRef = useRef(null);
  const [graphHeight, setGraphHeight] = useState(0);

  useEffect(() => {
    if (graphRef.current) {
      setGraphHeight(graphRef.current.offsetHeight);
    }
  }, [currentSurveyInsightData]);
  const mappedData = currentSurveyInsightData?.report_detail?.findings.reduce(
    (acc, finding) => {
      const sectionName = finding.section_name;
      const existingSection = acc.find(
        (item) => item.section_name === sectionName
      );
      const relatedRecommendations =
        currentSurveyInsightData?.report_detail?.recommendations.filter(
          (rec) => rec.finding_id === finding.finding_id
        );

      if (existingSection) {
        existingSection.recommendations.push(...relatedRecommendations);
      } else {
        acc.push({
          section_name: sectionName,
          recommendations: [...relatedRecommendations],
        });
      }

      return acc;
    },
    []
  );

  const contentRef = useRef(null);
  const headerRef = useRef(null);
  const tableHeaderRef = useRef(null);
  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // Tolerans payı
      setScrolling(isAtBottom);
    }
  };

  useEffect(() => {
    const survey_answers =
      currentSurveyInsightData?.report_detail?.survey_answers;
    if (survey_answers) {
      const processedAnswers = processSurveyAnswers(survey_answers);
      if (JSON.stringify(processedAnswers) !== JSON.stringify(totalAnswers)) {
        setTotalAnswers(processedAnswers);
      }
    }
  }, [currentSurveyInsightData]);

  const getColorForIndex = (index, total) => {
    const ratio = index / (total - 1);
    const r = Math.round(106 + ratio * (0 - 106));
    const g = Math.round(10 + ratio * (0 - 10));
    const b = Math.round(173 + ratio * (255 - 173));

    return `rgb(${r}, ${g}, ${b})`;
  };

  const steps = [
    {
      number: "01",
      title: "ASSESS THE BENEFIT",
      description:
        "Assess the benefit of each initiative in organizational context based on stakeholder inputs and Vision Workshop feedback",
      bgColor: "bg-[#44a5e4]",
    },
    {
      number: "02",
      title: "ESTIMATE THE EFFORT",
      description:
        "Effort is estimated based on potential complexity of the task, funding and stakeholder experience based on past efforts to solve a finding",
      bgColor: "bg-[#44a5e4]",
    },
    {
      number: "03",
      title: "PLAN FOR DEPENDENCIES",
      description:
        "Dependencies have been accounted for based on information available. Initiatives dependent on the completion of other initiatives or initiatives which need a longer planning phase have been identified as long-term projects",
      bgColor: "bg-[#44a5e4]",
    },
  ];

  const findings = currentSurveyInsightData?.report_detail?.findings || [];

  const groupedByType =
    currentSurveyInsightData?.report_detail?.recommendations?.reduce(
      (acc, item) => {
        const type = item.type || "Unknown"; // Type boşsa "Unknown" olarak ata

        if (!acc[type]) {
          acc[type] = {}; // Type'a göre boş obje oluştur
        }

        const key = `${item.benefit}-${item.ease_of_implementation}`; // Grup anahtarı

        // Finding ID ile eşleşen findings'leri bul ve benzersiz section'ları al
        const matchingSections = [
          ...new Set(
            findings
              .filter((finding) => finding.finding_id === item.finding_id)
              .map((finding) => finding.section_name)
          ),
        ];

        if (!acc[type][key]) {
          acc[type][key] = {
            benefit: item.benefit,
            ease_of_implementation: item.ease_of_implementation,
            benefits: [...item.benefits],
            risk_and_dependencies: item.risk_and_dependencies,
            strategies: [...item.strategies],
            recommendation_id: [item.recommendation_id],
            recommendation: [item.recommendation],
            recommendation_detail: [item.recommendation_detail],
            finding_id: item.finding_id, // Tek değer
            sections: matchingSections,
            id: [item.id],
          };
        } else {
          acc[type][key].benefits.push(...item.benefits);
          acc[type][key].risk_and_dependencies.push(
            ...item.risk_and_dependencies
          );
          acc[type][key].strategies.push(...item.strategies);
          acc[type][key].recommendation_id.push(item.recommendation_id);
          acc[type][key].recommendation.push(item.recommendation);
          acc[type][key].sections = [
            ...new Set([...acc[type][key].sections, ...matchingSections]),
          ]; // Unique section'ları güncelle
        }
        return acc;
      },
      {}
    );

  return (
    <div className="px-12 w-full my-8 min-h-screen flex flex-col overflow-y-auto ">
      
      <Graph
        themeMode={themeMode}
        data={currentSurveyInsightData?.report_detail}
        className=" "
      />
      {mappedData!==undefined &&(
      <div className="min-h-screen w-full flex flex-col ">
        <h1
          className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold  mb-10 ${
            themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
          }`}
        >
          RECOMMENDATION TO IMPLEMENT SOLUTION DOMAIN
        </h1>
        <div className="flex w-full">
          <h2
            className={`text-md md:text-lg font-bold mr-[1px] ${
              themeMode === "dark"
                ? "bg-black  text-white"
                : "text-black bg-white shadow-lg  border-r border-l border-gray-300 border-2"
            } p-2 w-1/3 text-center`}
          >
            SOLUTION DOMAIN
          </h2>
          <div className="flex-1 flex justify-center">
            <h2
              className={`text-md  md:text-lg font-bold  ${
                themeMode === "dark"
                  ? "bg-black  text-white"
                  : "text-black bg-white shadow-lg  border-r border-l border-gray-300 border-2"
              } p-2 w-full xl:w-full text-center border-l border-gray-300`}
            >
              RECOMMENDATIONS
            </h2>
          </div>
        </div>
        <div className="border border-gray-300">
          {mappedData?.map((section, sectionIndex) => (
            <div key={sectionIndex} className="flex">
              <div
                className={`w-1/3 p-4 text-white  flex items-center justify-center font-bold text-xs sm:text-sm md:text-lg`}
                style={{
                  backgroundColor: getColorForIndex(
                    sectionIndex,
                    mappedData.length
                  ),
                }}
              >
                {section.section_name}
              </div>
              <div className="w-2/3 p-4 border-l border-gray-300">
                <ul className="list-disc pl-4 text-base">
                  {section.recommendations.map((rec, idx) => (
                    <li
                      key={idx}
                      className={`text-xs sm:text-sm ${
                        themeMode === "dark" ? "text-gray-200" : "text-gray-700"
                      }`}
                    >
                      {rec.recommendation_detail}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      )}
      <div className="flex flex-col  w-full overflow-y-scroll justify-center">
        <h1
          className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold my-8 ${
            themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
          }`}
        >
          HOW THE RECOMMENDATIONS ARE PRIORITIZED
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-start w-full relative">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center w-full justify-start h-auto min-h-[300px]"
            >
              <div className="relative flex items-center justify-center w-48 h-48 rounded-full border-8 border-gray-200 z-10 mb-4">
                <div
                  className={`w-44 h-44 flex items-center justify-center rounded-full text-white font-bold text-[32px] absolute ${step.bgColor}`}
                >
                  {step.number}
                </div>
              </div>
              {index !== steps.length - 1 && (
                <div className="absolute top-24 w-full left-1 h-0 lg:border-t-2 lg:border-dashed lg:border-gray-400 z-1"></div>
              )}
              <div className="flex flex-col items-center text-center min-h-[120px]">
                <h3
                  className={`${
                    themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
                  } font-bold text-md sm:text-lg  mb-2`}
                >
                  {step.title}
                </h3>
                <p
                  className={`${
                    themeMode === "dark" ? "text-white" : "text-gray-600"
                  } text-base max-w-xs text-center`}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <TimelineChart themeMode={themeMode} /> */}
      {currentSurveyInsightData?.report_detail?.recommendations.length>0&&(
      <div className=" w-full  pt-8 flex flex-col">
        <h1
          className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold mb-10 ${
            themeMode === "dark" ? "text-white" : "text-black"
          }`}
        >
          RECOMMENDATION PRIORITIZATION
        </h1>
        <div className="w-full flex items-center flex-col 4xl:flex-row">
          <div className="w-full 4xl:w-2/3">
            <ul
              className={`space-y-0 divide-y h-full text-base ${
                themeMode === "dark" ? "divide-gray-200" : "divide-gray-500"
              }`}
            >
              {currentSurveyInsightData?.report_detail?.recommendations
                .filter((x) => x.type === "Quick Wins")
                .map((rec, index) => (
                  <li
                    key={rec.id}
                    className={`px-0 bg-[#fff] divide-x border flex  h-full ${
                      themeMode === "dark" ? "text-black" : "text-black "
                    } `}
                  >
                    <span className="px-2 py-1 w-10">{rec.id}</span>
                    <div className="px-2 py-1 flex flex-1">
                      {" "}
                      {rec.recommendation}
                    </div>
                  </li>
                ))}
              {currentSurveyInsightData?.report_detail?.recommendations
                .filter((x) => x.type === "Critical Enablers")
                .map((rec, index) => (
                  <li
                    key={rec.id}
                    className={`px-0 bg-[#cd80ff] divide-x border flex  h-full ${
                      themeMode === "dark" ? "text-black" : "text-black "
                    } `}
                  >
                    <span className="px-2 py-1 w-10">{rec.id}</span>
                    <div className="px-2 py-1 flex flex-1">
                      {" "}
                      {rec.recommendation}
                    </div>
                  </li>
                ))}
              {currentSurveyInsightData?.report_detail?.recommendations
                .filter((x) => x.type === "Long Term Initiatives")
                .map((rec, index) => (
                  <li
                    key={rec.id}
                    className={`px-0 bg-[#92d050] divide-x border flex  h-full ${
                      themeMode === "dark" ? "text-black" : "text-black "
                    } `}
                  >
                    <span className="px-2 py-1 w-10">{rec.id}</span>
                    <div className="px-2 py-1 flex flex-1">
                      {" "}
                      {rec.recommendation}
                    </div>
                  </li>
                ))}
              {currentSurveyInsightData?.report_detail?.recommendations
                .filter((x) => x.type === "De-prioritize")
                .map((rec, index) => (
                  <li
                    key={rec.id}
                    className={`px-0 bg-[#828282] divide-x border flex  h-full ${
                      themeMode === "dark" ? "text-black" : "text-black "
                    } `}
                  >
                    <span className="px-2 py-1 w-10">{rec.id}</span>
                    <div className="px-2 py-1 flex flex-1">
                      {" "}
                      {rec.recommendation}
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <BubbleChart
            className="w-[650px] mt-2"
            themeMode={themeMode}
            data={currentSurveyInsightData?.report_detail?.recommendations}
          />
        </div>
      </div>
      )}
      {groupedByType && Object.keys(groupedByType).length > 0 && (
      Object.entries(groupedByType)?.map(([type, items]) => {
        const allSections = [
          ...new Set(Object.values(items).flatMap((rec) => rec.sections || [])),
        ];
        const risk_and_dependencies = [
          Object.values(items).flatMap(
            (rec) => rec.risk_and_dependencies || []
          ),
        ];
        return (
          <div className=" w-full " key={type}>
            <h1
              className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold mb-10 ${
                themeMode === "dark" ? "text-white" : "text-black"
              }`}
            >
              {type}
            </h1>

            {Object.values(items).map((rec, index) => (
              <div className="grid  grid-cols-1  gap-4 mb-4">
               <div className="border p-4 rounded-lg shadow-lg">
                          <div className="flex items-center mb-2">
                            <span
                              className={`${
                                themeMode === "dark"
                                  ? "bg-[#44a5e4]"
                                  : "bg-[#44a5e4]"
                              } text-white px-3 py-1 rounded-md font-bold text-lg mr-2`}
                            >
                              {Array.isArray(rec.id)
                                ? rec.id.join(", ")
                                : rec.id}{" "}
                            </span>
                            {rec.recommendation.map((rec, i) => (
                              <h2
                                className={`font-bold text-lg ${
                                  themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                }`}
                              >
                                {Array.isArray(rec) ? rec.join(", ") : rec}{" "}
                              </h2>
                            ))}
                          </div>
                          <h3
                            className={`font-bold mt-2 ${
                              themeMode === "dark" ? "text-white" : "text-black"
                            }`}
                          >
                            DESCRIPTION
                          </h3>
                          <p className={`list-disc ml-5 text-base ${
                                  themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                }`}>
                            {rec.recommendation_detail}
                          </p>

                          <h3
                            className={`font-bold mt-2 ${
                              themeMode === "dark" ? "text-white" : "text-black"
                            }`}
                          >
                            WIN STRATEGY
                          </h3>
                          <ul className="list-disc ml-5 text-base">
                            {rec.strategies.map((item, index) => (
                              <li
                                key={index}
                                className={`${
                                  themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                }`}
                              >
                                {item}
                              </li>
                            ))}
                          </ul>
                          <h3
                            className={`font-bold mt-2  ${
                              themeMode === "dark" ? "text-white" : "text-black"
                            }`}
                          >
                            BENEFITS
                          </h3>
                          <ul className="list-disc ml-5 text-base">
                            {rec.benefits.map((item, index) => (
                              <li
                                key={index}
                                className={`${
                                  themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                }`}
                              >
                                {item}
                              </li>
                            ))}
                          </ul>
                          <h3
                            className={`font-bold mt-2  ${
                              themeMode === "dark" ? "text-white" : "text-black"
                            }`}
                          >
                            RISKS & DEPENDENCIES
                          </h3>
                          <ul className="list-disc ml-5 text-base">
                            {rec.risk_and_dependencies.map((risk, i) => (
                              <li
                                key={i}
                                className={`${
                                  themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                }`}
                              >
                                {risk}
                              </li>
                            ))}
                          </ul>
                          {/* Diğer alanlar */}
                        </div>
          
              </div>
            ))}

            <div className="border p-4 mt-4 rounded-lg hidden">
              <h3
                className={`font-semibold mt-2  ${
                  themeMode === "dark" ? "text-white" : "text-black"
                }`}
              >
                KEY STAKEHOLDERS
              </h3>
              <p
                className={`${
                  themeMode === "dark" ? "text-white" : "text-black"
                }`}
              >
                <strong>Owners:</strong> System Organization, Research Data
                Managers
              </p>
              <p
                className={`${
                  themeMode === "dark" ? "text-white" : "text-black"
                }`}
              >
                <strong>Collaborators:</strong> IT, Researchers
              </p>
            </div>

            <div
              className={` ${
                themeMode === "dark" ? "bg-[#44a5e4]" : "bg-[#44a5e4]"
              } text-white text-center p-4 mt-6 rounded-lg font-bold text-base`}
            >
              SUB-CAPABILITIES :
              <span className="ml-2">
                {allSections.length > 0 ? allSections.join(", ") : "N/A"}
              </span>
            </div>
          </div>
        );
      }))}
    </div>
  );
};
export default Recommendations;
